<jigsaw-root>
    <router-outlet></router-outlet>
</jigsaw-root>

